import {combineReducers} from 'redux';
import thunkMiddleware from 'redux-thunk';
import reactMetricsMiddleware from '@nib/react-metrics-redux';
import {metrics} from '../metrics';

import sessionReducer from './session/reducer';
import pricingReducer from './pricing/reducer';
import joinReducer from './join/reducer';
import previousFunds from './previousFunds/reducer';
import offerReducer from './offer/reducer';
import featureTogglesReducer from './featureToggles/reducer';
import excessesReducer from './excesses/reducer';
import ppcConfigReducer from './ppcConfig/reducer';
import lookupReducer from './lookup/reducer';
import stepper from './stepper/stepperSlice';
import {configureStore} from '@reduxjs/toolkit';
import {observe} from 'redux-observers';
import {fetchPriceObserver} from './observers/pricing';

const rootReducer = combineReducers({
  session: sessionReducer,
  pricing: pricingReducer,
  join: joinReducer,
  excesses: excessesReducer,
  previousFunds: previousFunds,
  offer: offerReducer,
  featureToggles: featureTogglesReducer,
  ppcConfigData: ppcConfigReducer,
  stepper: stepper,
  lookup: lookupReducer
});

export type IWHIJoinState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunkMiddleware, reactMetricsMiddleware(metrics)]
});

observe(store as any, [fetchPriceObserver]);

export default store;
